import { useMutation } from '@tanstack/react-query';
import { AiImageModelType, AiVideoModelEnum, axiosInstance } from '../../utils';
import { AIMedia } from '../../@types';

type Payload = {
  category: 'video' | 'image' | 'audio';
  prompt: string;
  name: string;
  duration?: number;
  uploadId?: string;
  uploadTailId?: string;
  orientation?: string;
  resolution?: number | string;
  model?: AiVideoModelEnum | AiImageModelType;
  style?: string;
  generateAudio?: boolean;
  enhancePrompt?: boolean;
  bodyControl?: boolean;
  isCharacterImage?: boolean;
  multiShot?: string;
};

const generateAiMedia = async (payload: Payload): Promise<AIMedia> => {
  const res = await axiosInstance.post('/api/stock-gallery/generate-ai-media', payload);
  return res.data;
};

export const useGenerateAiMedia = () => {
  return useMutation({
    mutationFn: generateAiMedia,
    onSuccess: (data) => data,
  });
};
